import styled from "styled-components";
import {ListTitleTextDefaultBox} from "./list-title-text.default.box";

export const ListTitleTextCipBox = styled(ListTitleTextDefaultBox)`
    font-family: ${props => props.theme.font.family.secondary};
`;